import { Member } from './types';
import { getAppInstance } from '@/utils/api/app';
import { ResidentialStatus } from '@/services/kashmir';
import {
  ResidentialStatus as MembershipResidentialStatus,
  GetMemberResponse,
  sortAddresses,
} from '@zopauk/api-membership-hub';

export const fetchUserProfile = async (): Promise<Member> => {
  const { data } = await getAppInstance().get<GetMemberResponse>('/members/me', {
    withCredentials: true,
  });

  if (!data) {
    throw new Error('No data returned from the API');
  }

  return {
    residentialStatus: getResidentialStatus(data.residentialStatus),
    addresses: sortAddresses(data.addresses!),
    dateOfBirth: data.dateOfBirth!,
    firstName: data.firstName!,
    email: data.emailAddress!,
    lastName: data.lastName!,
    id: data.memberId!,
  };
};

export function getResidentialStatus(
  membershipResidentialStatus: GetMemberResponse['residentialStatus'],
): ResidentialStatus | undefined {
  switch (membershipResidentialStatus) {
    case MembershipResidentialStatus.OwnerWithMortgage:
      return 'OWNER_WITH_MORTGAGE';
    case MembershipResidentialStatus.OwnerNoMortgage:
      return 'OWNER_NO_MORTGAGE';
    case MembershipResidentialStatus.Renting:
      return 'RENTING';
    default:
      return undefined;
  }
}
